import React from 'react';
import PropTypes from 'prop-types';

import { TableCard, ProductsTable } from 'src/components';
import { Spacer } from 'src/core/components';

const OverviewComponent = ({
  setSelectedMenuItem,
  data,
}) => data.map((dataItem) => dataItem.subcategories.map((subcategoryData) => {
  const category = {
    name: dataItem.category,
    categoryNr: dataItem.categoryNr
  };
  const subcategory = {
    name: subcategoryData.name,
    subcategoryNr: subcategoryData.subcategoryNr
  };

  return (
    <>
      <TableCard
        {...{
          category: category.name,
          subcategory: subcategory.name,
          onViewAll: () => setSelectedMenuItem({ category, subcategory }),
          expanded: !subcategoryData.designs?.length,
        }}
      >
        <ProductsTable
          category={category}
          subcategory={subcategory}
          products={subcategoryData.designs}
          isViewAllActive
        />
      </TableCard>
      <Spacer top={40} />
    </>
  );
}));

OverviewComponent.propTypes = {
  data: PropTypes.array.isRequired,
  setSelectedMenuItem: PropTypes.func.isRequired,
  isViewAllActive: PropTypes.bool,
};

export default OverviewComponent;
